<template>
  <transition name="post">
    <article v-if="allReady" class="post">
      <header class="post__header">

        <ul class="post__done-reading">
         <li class="nav__item" :to="`/`">
            <i class="nav__item--icon"></i>
            <router-link :to="`/`">
              <span class="nav__item--label">Go Back</span>
            </router-link> 
          </li>
        </ul>
        <div class="seperator"></div>

        <h2 class="post__title">{{ title }}</h2>

        <h3 class="post__meta">by <router-link class="post__author"
          :to="`/by/${kebabify(author)}`">{{ author }}</router-link>
          <span class="post__sep"></span>
          <time>{{ prettyDate(published) }}</time>
        </h3>
      </header>
      
      <section class="post__body rte">

        <div class="" v-for="paragraph in content" :key="paragraph">
          
          <div v-if="(isGist(paragraph) === false)" v-html="paragraph"></div>

          <vue-embed-gist v-if="isGist(paragraph)" :gist-id="getGist(paragraph)" />

        </div>
      </section>

      <footer class="post__footer">
        <h3>Share:</h3>
        <a class="social_outline twitter" v-bind:href="`${getTitterShareLink(id)}`" target="_blank">
          <font-awesome-icon :icon="['fab', 'twitter']" class="icon alt"/>
        </a>

        <a class="social_outline linkedin" v-bind:href="`${getLinkedInShareLink(id)}`" target="_blank">
          <font-awesome-icon :icon="['fab', 'linkedin']" class="icon alt"/>
        </a>

        <a class="social_outline envelope" href="https://www.linkedin.com/in/gerdedev/" target="_blank">
          <font-awesome-icon :icon="['fab', 'envelope']" class="icon alt"/>
        </a>

        <vue-disqus shortname="gerade" :key="post" :identifier="post" :url="`https://geradegeldenhuys.net/${post}`"/>

      </footer>
    </article>
  </transition>
</template>

<script>
import VueDisqus from 'vue-disqus/VueDisqus'
import { kebabify, prettyDate, getTitterShareLink, getLinkedInShareLink } from '../helpers'
import VueEmbedGist from 'vue-embed-gist'
var _ = require('underscore-node');

export default {
  name: 'blog-post',
  resource: 'BlogPost',
  components: { VueDisqus, VueEmbedGist },
  props: { post: String },

  data() {
    return {
      title: '',
      author: '',
      content: [],
      published: '',
      description: '',
      commentsReady: false,
      ready: false,
      gists: [],
      id: '',
      image:''
    }
  },

  computed: {
    allReady() {
      return this.ready && this.post;
    }
  },

  watch: {
    post(to, from) {
      if (to === from || !this.post) {
        this.title = "";
        return;
      }

      this.commentsReady = false
      this.$getResource('post', to)
        .then(this.showComments)
        .then(() => {
          this.ready = true;
        });
    }
  },

  methods: {
    kebabify,
    prettyDate,
    getTitterShareLink,
    getLinkedInShareLink,
    showComments() {
      // This is injected by prerender-spa-plugin on build time, we don't prerender disqus comments.
      if (window.__PRERENDER_INJECTED &&
          window.__PRERENDER_INJECTED.prerendered) {
        return;
      }

      setTimeout(() => {
        this.commentsReady = true
      }, 1000)
    },
    isGist(paragraph) {
      let gistRegex = new RegExp("^gist");
      return gistRegex.test(paragraph);
    },
    getGist(gist) {
      var gistObj = _.find(this.gists, function(g) { return g.name == gist; });
      return gistObj.id;
     }
  },
  metaInfo () {
    return {
      title:(this.title == '' ? undefined : this.title),
      meta: [
        { vmid: 'og:description', name: 'og:description', content: (this.title == '' ? undefined : this.title)},
        { vmid: 'description', name: 'description', content: (this.title == '' ? undefined : this.title)},
        { vmid: 'og:title', name: 'og:title', content: (this.title == '' ? undefined : this.title) },
        { vmid: 'author', name: 'author', content: 'Gerade Geldenhuys' },
        { vmid: 'image', name: 'og:image', content: (this.image == '' ? undefined : this.image) },
        { vmid: 'og:description', name: 'og:description', content: (this.title == '' ? undefined : this.title) },
        { vmid: 'twitter:image:src', name: 'twitter:image:src', content: (this.image == '' ? undefined : this.image) },
        { vmid: 'twitter:title', name: 'twitter:title', content: (this.title == '' ? undefined : this.title) },
        { vmid: 'twitter:description', name: 'twitter:description', content: (this.title == '' ? undefined : this.title)} 
      ]
    }
  },
  mounted() {
    if (!this.post) {
      this.ready = true;
      return;
    }
    this.$getResource('post', this.post)
      .then(this.showComments)
      .then(() => {
        this.ready = true;
      });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogPost.vue